// extracted by mini-css-extract-plugin
module.exports = {"SearchArea":"SearchInput_SearchArea__SQ8SP","SearchInput":"SearchInput_SearchInput__Be9aU","SearchIcon":"SearchInput_SearchIcon__StNEU"};